<template>
    <div class="human-message" @click="copyToClipboard">
        <div class="message-wrapper">
            <div v-if="profilePicture && userName" class="user-header">
                <div class="user-name">{{ firstName }}</div>
                <div class="profilePicture"><img :src="profilePicture" alt="Profile Picture" /></div>
            </div>
            <div class="message-text">{{ text }}</div>
        </div>
        <div v-if="showTimestamp" class="timestamp">{{ formattedTimestamp }}</div>
        <div class="triangle"></div>
    </div>
</template>

<script>
export default {
    watch: {
        userName(userName) {
            this.firstName = userName.split(' ')[0];
        }
    },
    created() {
        if (this.userName) {
            this.firstName = this.userName.split(' ')[0];
        }
    },
    data() {
        return {
            firstName: ''
        };
    },
    props: {
        text: {
            type: String,
            required: true
        },
        timestamp: {
            type: String,
            required: true
        },
        conversation_id: {
            type: String,
            required: true
        },
        profilePicture: {
            type: String,
            required: false
        },
        userName: {
            type: String,
            required: false
        },
        showTimestamp: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    computed: {
        formattedTimestamp() {
            let date;
            if (this.timestamp && this.timestamp !== '') {
                // Use the provided timestamp from DB
                date = new Date(this.timestamp + 'Z'); // Ensure the timestamp is treated as UTC
            } else {
                // Fallback to current time only if no timestamp provided
                date = new Date();
            }
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            };
            return date.toLocaleString('es-AR', options);
        }
    },
    methods: {
        copyToClipboard() {
            navigator.clipboard.writeText(this.text);
        }
    }
};
</script>

<style scoped>
.human-message {
    cursor: pointer;
    margin-bottom: 24px;
    background-color: #eee;
    align-self: flex-end;
    padding: 12px 24px;
    padding-top: 18px;
    border-radius: 12px 12px 0 12px;
    box-shadow: -5px 0 12px 1px rgba(0, 0, 0, 0.1);
    border: 1px solid #ccc;
    position: relative;
    font-size: 15pt;
    max-width: 40%;
}

.timestamp {
    color: gray;
    padding-left: 0;
}

.triangle {}


.triangle::before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 24px solid transparent;
    border-top: 24px solid #f0f0f0;
    right: 1px;
    bottom: -25px;
}

.user-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 12px;
}

.user-name {
    font-weight: bold;
    margin-right: 12px;
}

.profilePicture {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    border: 2px solid #333;
}

.profilePicture img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}


@media screen and (max-width: 768px) {
    .human-message {
        max-width: 80%;
    }

}
</style>
